/* ****************
 * GENERATED CODE *
 **************** */

import { BasicEvent } from "@h4x/common";
import { HewSyncList } from "../../system/HewSyncList";
import { HewSyncType } from "../../system/HewSyncType";
import { HewSync, type Writeable } from "../../system/HewSync";
import { AdminGroupID, AdminOrganizationID } from "../../system/IDs";

@HewSync.Type({
	name: "AdminGroup",
	scope: "Admin",
	table: "admin",
	type: "Admin:Group"
})
export class AdminGroup extends HewSyncType {
	public static readonly Type = AdminGroup as typeof HewSyncType;
	public static override readonly type = "AdminGroup";
	public override readonly type = AdminGroup.type;

	@HewSync.Field({})
	public readonly group: AdminGroupID;

	@HewSync.Field({})
	public readonly organization: AdminOrganizationID;

	@HewSync.Field({})
	public readonly description: string;

	@HewSync.Field({})
	public readonly name: string;

	@HewSync.Field({})
	public readonly createdAt: HewSync.Timestamp;

	@HewSync.Field({})
	public readonly updatedAt: HewSync.Timestamp;

	/********************************************/

	public static get(ids: AdminGroup.IDs) {
		this.initSubscriptions();

		let key = this.getKey(ids);
		let item = this.cache.get(key);

		if (item === undefined) {
			item = new AdminGroup({
				...AdminGroup.defaults(),
				group: ids.group,
				organization: ids.organization
			});
			this.cache.set(key, item);
			item.fetch(item.ids);
		}

		return item;
	}

	public static rawGet(ids: AdminGroup.IDs) {
		return HewSync.get<AdminGroup>(AdminGroup.Type, ids);
	}

	public static list(/*...*/) {
		// TODO
	}

	public static listBy(params?: Partial<AdminGroup.IDs>): HewSyncList<AdminGroup> {
		let list = new (HewSyncList as any)(AdminGroup.Type, undefined, params);
		return list;
	}

	public static rawList(inputs: Partial<AdminGroup.IDs> & { limit?: number; nextToken?: string }) {
		return HewSync.list<AdminGroup>(AdminGroup.Type, inputs);
	}

	public static batchGet(ids: AdminGroup.IDs[]) {
		return HewSync.batchGet<AdminGroup>(AdminGroup.Type, ids);
	}

	public static create(values: AdminGroup.Create) {
		return HewSync.create<AdminGroup>(AdminGroup.Type, "create", values);
	}

	public static update(
		ids: AdminGroup.IDs,
		values: Partial<Pick<AdminGroup, AdminGroup.Modifiable>>,
		target?: AdminGroup
	) {
		return HewSync.request<AdminGroup>(AdminGroup.Type, "update", { ...values, ...ids }, target);
	}

	public static remove(ids: AdminGroup.IDs, target?: AdminGroup) {
		return HewSync.request<AdminGroup>(AdminGroup.Type, "remove", ids, target);
	}

	/********************************************/

	public update(values: Partial<Pick<AdminGroup, AdminGroup.Modifiable>>) {
		return AdminGroup.update(this.ids, values, this);
	}

	public remove() {
		return AdminGroup.remove(this.ids, this);
	}

	/********************************************/

	private static cache = new Map<string, AdminGroup>();

	public get ids() {
		return { organization: this.organization, group: this.group };
	}

	public static getKey(ids: AdminGroup.IDs) {
		return ids.organization.toString() + "/" + ids.group.toString();
	}

	public get key() {
		return this.organization.toString() + "/" + this.group.toString();
	}

	protected constructor(data: any) {
		super(Symbol.for("HewSyncType::Internal::Create") as unknown as void);

		(this as any).group = data.group;
		(this as any).organization = data.organization;

		this.apply({ ...AdminGroup.defaults(), ...data });
	}

	protected override apply(data: Partial<AdminGroup.Fields>) {
		(this as any).description = data.description;
		(this as any).name = data.name;
		(this as any).createdAt = data.createdAt;
		(this as any).updatedAt = data.updatedAt;
		this.onUpdate.execute(this);
	}

	protected static defaults() {
		let values = {} as AdminGroup;
		(values as any).description = "";
		(values as any).name = "";
		(values as any).createdAt = new HewSync.Timestamp("1970-01-01T00:00:00Z");
		(values as any).updatedAt = new HewSync.Timestamp("1970-01-01T00:00:00Z");
		return values;
	}

	protected static parse(data: any): Partial<AdminGroup.IDs & AdminGroup.Fields> {
		let output: Partial<Writeable<AdminGroup.IDs & AdminGroup.Fields>> = {};
		if (data.group !== undefined && data.group !== null) {
			output.group = new AdminGroupID(data.group);
		}
		if (data.organization !== undefined && data.organization !== null) {
			output.organization = new AdminOrganizationID(data.organization);
		}
		if (data.description !== undefined && data.description !== null) {
			output.description = data.description;
		}
		if (data.name !== undefined && data.name !== null) {
			output.name = data.name;
		}
		if (data.createdAt !== undefined && data.createdAt !== null) {
			output.createdAt = new HewSync.Timestamp(data.createdAt);
		}
		if (data.updatedAt !== undefined && data.updatedAt !== null) {
			output.updatedAt = new HewSync.Timestamp(data.updatedAt);
		}
		return output;
	}

	protected toJSON(): any {
		return {
			group: this.group,
			organization: this.organization,
			description: this.description,
			name: this.name,
			createdAt: this.createdAt,
			updatedAt: this.updatedAt
		};
	}

	private static onSubscriptionEvent = new BasicEvent<(data: any) => void>();

	private static subscriptionsInitialized = false;
	static initSubscriptions() {
		if (this.subscriptionsInitialized === false) {
			void HewSync.initSubscriptions(this.Type, this.onSubscriptionEvent);
			this.subscriptionsInitialized = true;
		}
	}

	public static readonly fieldIDs = ["organization", "group"] as const;
	public readonly fieldIDs = AdminGroup.fieldIDs;
	public static readonly fields = ["description", "name", "createdAt", "updatedAt"] as const;
	public readonly fields = AdminGroup.fields;
}

export namespace AdminGroup {
	export type IDs = Pick<AdminGroup, AdminGroup.IDNames>;
	export type IDNames = "organization" | "group";
	export type Fields = Pick<AdminGroup, AdminGroup.FieldNames>;
	export type FieldNames = "description" | "name" | "createdAt" | "updatedAt";
	export type Modifiable = "description" | "name";
	export type Create = {
		organization: AdminOrganizationID;
		description?: string;
		name: string;
	};
}
